var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "#4987FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8474 21.2087C26.776 21.2201 26.7037 21.2254 26.6314 21.2245H15.9791L16.2476 21.3477C16.5101 21.4702 16.7488 21.637 16.9532 21.8406L20.4063 25.2475C20.8611 25.6759 20.9375 26.3649 20.5874 26.8802C20.1799 27.4293 19.3985 27.5485 18.842 27.1464C18.797 27.1139 18.7543 27.0785 18.7141 27.0404L12.4698 20.8794C11.9818 20.3985 11.9814 19.6183 12.4688 19.1369L18.7141 12.975C19.2025 12.4945 19.9932 12.4955 20.4803 12.9774C20.5186 13.0153 20.5544 13.0557 20.5874 13.0982C20.9375 13.6134 20.8611 14.3025 20.4063 14.7308L16.9595 18.144C16.7762 18.325 16.5656 18.4767 16.335 18.5937L15.9604 18.7601H26.5627C27.2007 18.7367 27.7604 19.1764 27.8802 19.7951C27.9906 20.4669 27.5282 21.0997 26.8474 21.2087Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow.cbdadfd0a67a3fd672d8da18194e6d85.svg";